import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const CSV_TYPE = 'text/csv;charset=utf-8';

@Injectable({
  providedIn: 'root'
})
export class ExportExcelService {
  EXCEL_EXTENSION = '.xlsx';
  constructor() { }

  get excelExtension(): string {
    return this.EXCEL_EXTENSION;
  }

  set excelExtension(extension: string) {
    this.EXCEL_EXTENSION = extension;
  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };

    XLSX.utils.book_append_sheet(workbook, worksheet)
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  public exportAsCsvFile(json: any[], fileName: string): void {
    const csvData = this.convertToCsv(json);
    this.saveAsFile(csvData, fileName, CSV_TYPE);
  }
  // private convertToCsv(json: any[]): string {
  //   const headers = Object.keys(json[0]);

  //   const rows = json.map(item => headers.map(header => item[header]).join(','));
  //   return [headers.join(','), ...rows].join('\n');
  // }

  private convertToCsv(json: any[]): string {
    const headers = Object.keys(json[0]);
    
    // Escape values that contain commas or double quotes
    const escapeCsvValue = (value: any) => {
      // If value is null or undefined, return an empty string
      if (value === null || value === undefined) {
        return '';
      }

      // Convert value to string
      let strValue = String(value);
      // If the value contains a comma or a quote, wrap it in quotes and escape any quotes inside
      if (strValue.includes(',') || strValue.includes('"') || strValue.includes('\n')) {
        strValue = `"${strValue.replace(/"/g, '""')}"`;  // Double the quotes inside the string
      }
      return strValue;
    };
    const rows = json.map(item => headers.map(header => escapeCsvValue(item[header])).join(','));
    return [headers.join(','), ...rows].join('\n');
  }

  private saveAsFile(data: any, fileName: string, fileType: string): void {
    const blob: Blob = new Blob([data], { type: fileType });
    FileSaver.saveAs(blob, `${fileName}_export_${new Date().getTime()}${this.EXCEL_EXTENSION}`);
  }
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + this.EXCEL_EXTENSION);
  }
}
